<template>
  <b-card class="m-3" no-body>
    <b-card-body>
      <b-row class="text-justify mb-3" v-if="prestacao">
        <b-col cols="12">
          <span>ID: </span>
          <span>{{ prestacao.IdPrestacaoConta }}</span>
        </b-col>
        <b-col cols="12">
          <span>CPF de entrega: </span>
          <span>{{ prestacao.UsuarioEntrega }}</span>
        </b-col>
        <b-col cols="12">
          <span>Ano/Mês: </span>
          <span>{{ prestacao.Ano }}/{{ prestacao.Mes }}</span>
        </b-col>
        <b-col cols="12">
          <span>Tipo de Entrega: </span>
          <span>{{ prestacao.TipoEntrega }}</span>
        </b-col>
        <b-col cols="12">
          <span>Tipo de Prestação: </span>
          <span>{{ prestacao.TipoPrestacao }}</span>
        </b-col>
        <b-col cols="12" v-if="prestacao.DataEntrega">
          <span>Data de Entrega: </span>
          <span>{{ prestacao.DataEntrega.toLocaleDateString() }}</span>
        </b-col>
        <b-col cols="12">
          <span>Situação: </span>
          <span>{{ textoSituacao }}</span>
        </b-col>
        <b-col cols="6" class="text-center mt-2">
          <BtnDownload :fazerDownload="downloadArquivo" texto="Cópia da Entrega" />
        </b-col>
        <b-col v-if="prestacao.DsStatusPc === 'Processada'" cols="6" class="text-center mt-2">
          <BtnDownload :fazerDownload="downloadRecibo" texto="Recibo de Entrega" />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { store } from "@/store";
import pcmService from "@/services/entregas/pcmService"
import BtnDownload from "@/components/shared/btn-download.vue"
import { mixins } from 'vue-class-component';
import { UtilsTS } from '@/utilsts';
import { PortalError } from '@/types/portal-error';
import { situacoesEmFila } from '@/types/entregas/pcm/fields-prestacao-contas-mensal';


const CompProps = Vue.extend({
  name: 'InformacoesEntregaPCM',
  components: { BtnDownload },
  props: {
    idpcm: {
      type: String
    }
  },
})

@Component
export default class DetalhesEntregaPCM extends mixins(UtilsTS, CompProps) {
  prestacao: any = {}
  pdfData = ''

  get textoSituacao(): string {
    if(!this.prestacao || !this.prestacao.DsStatusPc)
      return ''
    if (situacoesEmFila.includes(this.prestacao.DsStatusPc))
      return 'Em Fila'
    return this.prestacao.DsStatusPc
  }

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true
      this.prestacao = await pcmService.getByID(Number(this.idpcm))
      // console.log(this.prestacao)
    } catch (e: any) {
      this.$toast.error(e.message ? e.message : e);
      this.$router.push('/entrega/prestacoes-contas-mensais');
    } finally {
      store.blockScreen = false
    }
  }

  async downloadArquivo(): Promise<void> {
    const response = await pcmService.downloadEntrega(this.prestacao.IdPrestacaoConta);
    if (response && response.status == 200) {
      this.download(`entrega-pcm-${this.prestacao.IdPrestacaoConta}`, response.data);
    } else {
      if (response && response.data && response.data.msg)
        this.$toast.error(response.data.msg);
      else this.$toast.error("Erro ao obter o arquivo");
    }
  }

  async downloadRecibo(): Promise<void> {
    this.pdfData = ''
    const response = await pcmService.downloadRecibo(this.prestacao.IdPrestacaoConta);
    //console.log("response", response)
    if (response.data.ArquivoPdf) {
      const blob = this.base64ToPdf(response.data.ArquivoPdf)
      this.pdfData = URL.createObjectURL(blob)
      //console.log("pdfData", this.pdfData)
      this.downloadFromUrl(`recibo-pcm-${this.prestacao.IdPrestacaoConta}.pdf`, this.pdfData)
    } else throw new PortalError('Erro ao obter o recibo da PCM')
  }

  //TODO: chamar no mixin UtilsTS
  download(filename: string, content: any): void {
    var element = document.createElement('a');
    element.setAttribute('href', URL.createObjectURL(content));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
};
</script>
<style scoped>
div.row>div>span:first-child {
  font-weight: bolder;
  /*display: block;*/
}
</style>